const faqs = [
  {
    q: '51cg是什么平台？',
    a: '51cg是一个综合性内容平台，汇集了丰富的资讯、社区讨论和互动内容。用户可以在平台上浏览各类话题内容、参与社区讨论，获取多领域的信息资源。本站作为导航站点，提供51cg官方网址入口与平台介绍。',
  },
  {
    q: '51cg.fun是什么？和51cg有什么关系？',
    a: '51cg.fun是51cg平台的官方域名之一。由于平台域名可能因各种原因发生变更，51cg.fun是当前可用的官方域名入口。本站会持续追踪并更新所有51cg相关域名的可用状态。',
  },
  {
    q: '如何找到51cg的最新可用网址？',
    a: '您可以通过本导航站首页的"专题索引"和"动态快讯"模块获取51cg最新域名信息。我们实时追踪域名变更动态，确保您始终能够通过正确的官方入口访问51cg平台。',
  },
  {
    q: '访问51cg时遇到连接问题怎么办？',
    a: '首先确认您使用的是本站收录的最新官方域名。如仍有问题，可以尝试更换网络环境、清除浏览器缓存，或查看"动态快讯"中是否有域名变更通知。如果问题持续，可能是网络运营商限制导致。',
  },
  {
    q: '51cg平台是否安全？',
    a: '51cg官方平台本身是安全的。但需要注意识别仿冒站点，只使用本导航站收录的官方域名进行访问。请勿在非官方渠道输入个人敏感信息，避免钓鱼风险。本导航站会对收录的域名进行多重验证。',
  },
  {
    q: '51cg支持移动端访问吗？',
    a: '支持。51cg已对移动端浏览器进行全面适配，您可以直接在手机浏览器中输入官方域名访问，无需下载任何应用。移动端页面加载速度与交互体验均经过优化，使用流畅。',
  },
];

export default function FaqSection() {
  return (
    <section id="faq" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">常见问题</h2>
          <p className="mt-3 text-sm text-foreground-500 max-w-xl mx-auto">关于51cg平台与网址导航的常见疑问解答</p>
        </div>

        <div className="max-w-3xl mx-auto divide-y divide-background-200/60">
          {faqs.map((faq, i) => (
            <div key={i} className="py-5 md:py-6">
              <h3 className="text-sm md:text-base font-bold text-foreground-900 mb-2">{faq.q}</h3>
              <p className="text-sm text-foreground-600 leading-relaxed">{faq.a}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}